import {
  clickEventType,
  openConfirmationPopup,
  openPopup,
  showUploadedPhotos,
} from '../helpers';
import {
  checkHovering,
  timeToFloat,
  updateClockIconColor,
  stylePopup,
  setMobilePopupWidth,
  getDateFromEmployeeDay,
  getProjectId,
  getEmployeeId,
  getSupervisorId,
  openHover,
  validStringForTime,
  isTaskBasedView,
  showManagePlannedEmployeesPopup,
} from './shared';
import { showFlashMessage } from '../flash';

$(document).ready(() => {
  $(document).on('click', '#employee_planner_view .task_hover', function () {
    const date = getDateFromEmployeeDay($(this));
    const supervisorId = getSupervisorId($(this));
    const projectId = getProjectId($(this));
    const employeeId = getEmployeeId($(this));
    const data = {
      employee_id: employeeId, project_id: projectId, supervisor_id: supervisorId, date,
    };
    $.ajax({
      url: '/planned_employee_days/tasks',
      type: 'GET',
      data,
      success(data) {
        const selector = '#tasks_popup';
        const openCallback = function () {
          $(selector).data('date', date);
          $(selector).data('supervisorId', supervisorId);
          $(selector).data('projectId', projectId);
          $(selector).data('employeeId', employeeId);
          stylePopup(selector);
        };
        const closeCallback = function () {
          $(selector).dialog('destroy');
          drawPlanner(false);
        };
        openPopup(selector, data, openCallback, closeCallback);
      },
    });
    return false;
  });

  $(document).on('click', '#tasks_popup #new_task', function () {
    $('#tasks_popup').closest('.ui-dialog').hide();
    const context = contextWithDataForNewTaskPopup($(this));
    const date = context.data('date');
    const employeeId = context.data('employeeId');
    const projectId = context.data('projectId');
    const supervisorId = context.data('supervisorId');
    $.ajax({
      url: '/planned_employee_days/employee_competencies',
      type: 'GET',
      data: {
        date,
        employee_id: employeeId,
        project_id: projectId,
        supervisor_id: supervisorId,
      },
      success(data) {
        const selector = '#new_task_popup';
        const openCallback = function () {
          $(selector).data('date', date);
          $(selector).data('employeeId', employeeId);
          $(selector).data('projectId', projectId);
          $(selector).data('supervisorId', supervisorId);
          stylePopup(selector);
          $(selector).data('date', date);
          $(selector).data('employeeId', employeeId);
          $(selector).data('projectId', projectId);
          $(selector).data('supervisorId', supervisorId);
          $(selector).dialog('option', 'autoSize', true);
        };
        const closeCallback = function () {
          $(selector).dialog('destroy');
          $('#tasks_popup').closest('.ui-dialog').show();
          drawPlanner(false);
        };
        openPopup(selector, data, openCallback, closeCallback);
      },
    });
    return false;
  });

  function contextWithDataForNewTaskPopup(element) {
    let result = null;
    if ($('#planner-mobile').length) {
      result = element.closest('.employee_mobile');
    } else if ($('#end-of-day-wizard .summary-step').length) {
      result = $('#summary-step-data');
    } else {
      result = element.closest('#tasks_popup');
    }
    return result;
  }

  $(document).on('click', '#tasks_planner_view .add_task, .task_day_mobile .add_task', function () {
    open_add_task_popup(this);
  });

  function open_add_task_popup(context) {
    const supervisorId = $(context).data('supervisorId');
    const projectId = $(context).data('projectId');
    const date = $(context).data('date');
    const data = { supervisor_id: supervisorId };
    const selector = '#new_task_popup';
    const openCallback = function () {
      $(selector).data('date', date);
      $(selector).data('supervisorId', supervisorId);
      $(selector).data('projectId', projectId);
      stylePopup(selector);
      $(selector).dialog('option', 'width', setMobilePopupWidth());
      $(selector).dialog('option', 'autoSize', true);
    };
    const closeCallback = function () {
      $(selector).dialog('destroy');
    };
    const openNewTaskPopupCallback = function (content) {
      openPopup(selector, content, openCallback, closeCallback);
    };
    showCompetencies(data, openNewTaskPopupCallback);
    return false;
  }

  $(document).on('click', '.competency', function () {
    // HANDLE DATES WITH FUTURE TASK VAR !
    const competencyId = $(this).data('companyCompetencyId');
    const otherTasksMode = $('#new_task_popup').data('otherTasksMode');
    const competencyHasChildren = $(this).data('hasChildren');
    const employeeId = $('#tasks_popup').data('employeeId');
    let date = $('#tasks_popup').data('date');
    const today = new Date();
    if ($(this).parents('#new_task_popup').length === 0) {
      const dateObj = new Date(date.substring(6, 10), date.substring(3, 5) - 1, date.substring(0, 2));
      const futureDate = (dateObj > today);
    }
    var data = {};
    if (competencyHasChildren && !otherTasksMode) {
      date = date || $.datepicker.formatDate('dd/mm/yy', today);
      data = {
        competency_id: competencyId,
        employee_id: employeeId,
        date,
        only_competencies_section: true,
      };
      showCompetencies(data);
    } else {
      $('body').css({ overflow: 'inherit' });
      date = $('#new_task_popup').data('date');
      const supervisorId = $('#new_task_popup').data('supervisorId');
      $('#new_task_popup').dialog('destroy');
      if (isTaskBasedView()) {
        var data = {
          supervisor_id: supervisorId,
          competency_id: competencyId,
        };
        if ($('.task_day_mobile').first().is(':visible')) {
          data.date = date;
        }
        showFinalStepForCreatingPlannedTask(data);
      } else {
        createTask(date, $(this));
      }
    }
    return false;
  });

  function getConfirmationAboutAddingEmployees(data, taskIds) {
    const content = '<p>Would you like to add employees now?</p>';
    const popupSelector = '#confirmation_popup';
    const options = [
      {
        text: 'Yes',
        click() {
          addEmployeesToPlannedTask(data, taskIds);
          $(popupSelector).dialog('destroy');
        },
      },
      {
        text: 'No',
        click() {
          $(popupSelector).dialog('destroy');
        },
      },
    ];
    const openCallback = function () { stylePopup(popupSelector); };
    openConfirmationPopup(popupSelector, content, openCallback, null, options);
  }

  function addEmployeesToPlannedTask(dataAttributes, taskIds) {
    const data = {
      task_id: taskIds[0],
      task_class: 'PlannedTask',
      date: dataAttributes.planned_from,
      project_id: dataAttributes.project_id,
      supervisor_id: dataAttributes.supervisor_id,
      competency_id: dataAttributes.competency_id,
    };
    const datesRangeSection = `<div> \
        <h3>Dates range:</h3> \
        <span>${dataAttributes.planned_from} - ${dataAttributes.planned_to}</span> \
      </div>`;
    const preparePopup = function () {
      $('#required_employees_section').hide();
      $('#required_employees_section').after(datesRangeSection);
      $('#manage_planned_employees_popup').data('taskIds', taskIds);
      $('#manage_planned_employees_popup').data('plannedFrom', dataAttributes.planned_from);
      $('#manage_planned_employees_popup').data('plannedTo', dataAttributes.planned_to);
      $('#manage_planned_employees_popup').data('onlyPlannedEmployees', true);
    };
    showManagePlannedEmployeesPopup(data, preparePopup);
  }

  function showFinalStepForCreatingPlannedTask(data) {
    $.ajax({
      url: 'planned_employee_days/planned_task_final_step',
      type: 'GET',
      data,
      success(data) {
        const selector = '#planned_task_final_step_popup';
        const openCallback = function () {
          stylePopup(selector);
          const minDate = new Date();
          minDate.setDate(minDate.getDate() + 1);
          $('.datepicker').datepicker({ minDate, dateFormat: 'dd/mm/yy' });
        };
        const closeCallback = function () {
          $(selector).dialog('destroy');
          drawPlanner(false);
        };
        openPopup(selector, data, openCallback, closeCallback);
      },
    });
    return false;
  }

  let ajaxRequest = null;
  function showCompetencies(data, callback) {
    if (ajaxRequest !== null) { ajaxRequest.abort(); }
    ajaxRequest = $.ajax({
      url: '/planned_employee_days/company_competencies',
      type: 'GET',
      data,
      success(content) {
        $('#new_task_popup #competencies_section').html(content);
        if (callback) { callback(content); }
      },
    });
  }

  function createTask(date, competency, description) {
    const contextWithData = $('#new_task_popup');
    const employeeId = contextWithData.data('employeeId');
    const projectId = contextWithData.data('projectId');
    const supervisorId = contextWithData.data('supervisorId');
    if (competency) {
      var competencyId = competency.data('companyCompetencyId');
    }
    const taskParams = {
      supervisor_id: supervisorId,
      competency_id: competencyId,
      description,
    };
    $.ajax({
      url: '/planned_employee_days/create_task',
      type: 'POST',
      data: {
        date,
        employee_id: employeeId,
        project_id: projectId,
        supervisor_id: supervisorId,
        task: taskParams,
      },
      success(data) {
        if ($('#planner-mobile').length) {
          const summaryStepData = $('#end-of-day-wizard #summary-step-data');
          const context = summaryStepData.length ? summaryStepData : $('#new_task_popup');
          showEmployeeDayTasks(date, context, true);
        } else if ($('#end-of-day-wizard .summary-step').length) {
          $('#end-of-day-wizard .summary-step .employee_tasks').html(data);
        } else {
          $('#tasks_popup').html(data);
          $('#tasks_popup').closest('.ui-dialog').show();
        }
      },
    });
  }

  function showEmployeeDayTasks(date, context, keepOpen) {
    const employeeId = getEmployeeIdMobile(context);
    const employeeMobile = $(`.employee_mobile[data-date="${date}"]`);
    let element = employeeMobile.find(`#toggle_employee_details_${employeeId}`);
    if ($('#end-of-day-wizard .employee-details-content').length) {
      element = $('#end-of-day-wizard .employee-details-content');
    }
    if (element.is(':visible') && !keepOpen) {
      element.hide();
    } else {
      const supervisorId = getSupervisorIdMobile(context);
      const projectId = getProjectIdMobile(context);
      const data = {
        employee_id: employeeId, project_id: projectId, supervisor_id: supervisorId, date,
      };
      $.ajax({
        url: '/planned_employee_days/tasks',
        type: 'GET',
        data,
        success(data) {
          element.html(data);
          const employeeDetails = element.children('.employee_details');
          employeeDetails.data('employeeId', employeeId);
          const tasksPopup = employeeDetails.children('#tasks_popup');
          tasksPopup.data('date', date);
          tasksPopup.data('employeeId', employeeId);
          tasksPopup.data('supervisorId', supervisorId);
          tasksPopup.data('projectId', projectId);
          element.show();
          if ($('#planner-mobile').length) { updateClockIconColor(employeeDetails); }
          const employeeMobile = $(`.employee_mobile[data-date="${date}"][data-employee-id="${employeeId}"]`);
          updateCounter('employees', employeeMobile);
        },
      });
    }
  }

  function getProjectIdMobile(context) {
    return context.data('projectId');
  }

  function getSupervisorIdMobile(context) {
    return context.data('supervisorId');
  }

  function getEmployeeIdMobile(context) {
    return context.data('employeeId');
  }

  $(document).on('click', '#other-activities', () => {
    const employeeId = $('#tasks_popup').data('employeeId');
    const date = $('#tasks_popup').data('date');
    $.ajax({
      url: '/planned_employee_days/company_competencies',
      type: 'GET',
      data: {
        date,
        employee_id: employeeId,
      },
      success(data) {
        $('#new_task_popup').html(data);
        $('#new_task_popup').data('otherTasksMode', true);
        $('#other-activities, #search_for_activity, #add_new_task').hide();
      },
    });
    return false;
  });

  $(document).on('click', '#new_task_popup .custom-activity', function () {
    const description = $(this).text();
    createCustomTask(description);
  });

  $(document).on('click', '#save_new_custom_task', () => {
    const description = $('#search_for_activity').val();
    createCustomTask(description);
  });

  function createCustomTask(description) {
    const date = $('#new_task_popup').data('date');
    $('#new_task_popup').dialog('destroy');
    $('body').css({ overflow: 'inherit' });
    if (isTaskBasedView()) {
      const supervisorId = $('#new_task_popup').data('supervisorId');
      const data = {
        description,
        supervisor_id: supervisorId,
        date,
      };
      showFinalStepForCreatingPlannedTask(data);
    } else {
      createTask(date, undefined, description);
    }
  }

  $(document).on('keyup', '#search_for_activity', function () {
    const date = $('#new_task_popup').data('date');
    const employeeId = $('#new_task_popup').data('employeeId');
    const supervisorId = $('#new_task_popup').data('supervisorId');
    const activityName = $(this).val();
    const competencyId = $('#new_task_popup #parent_competency').data('companyCompetencyId');
    const data = {
      date,
      employee_id: employeeId,
      competency_id: competencyId,
      activity_name: activityName,
      supervisor_id: supervisorId,
      only_competencies_section: true,
    };
    const callback = function () {
      const searchField = $('#search_for_activity');
      if (searchField.val().length) {
        $('#new_task_popup #parent_competency, #new_task_popup .planned_tasks').hide();
      } else {
        $('#new_task_popup .planned_tasks').show();
      }
    };
    showCompetencies(data, callback);
  });

  $(document).on('mouseover', '#employee_planner_view .task_hover', function (event) {
    if (checkHovering(event, this)) {
      const date = getDateFromEmployeeDay($(this));
      const supervisorId = getSupervisorId($(this));
      const projectId = getProjectId($(this));
      const employeeId = getEmployeeId($(this));
      const data = {
        employee_id: employeeId, project_id: projectId, supervisor_id: supervisorId, date,
      };
      const context = this;
      $.ajax({
        url: '/planned_employee_days/tasks',
        type: 'GET',
        data,
        success(data) {
          openHover(data, context, hideElementsForTasksHoverPopup);
        },
      });
    }
  });

  function hideElementsForTasksHoverPopup() {
    $('.employee_day_task .delete_task').hide();
    $('#hover_popup #new_task').hide();
  }

  $(document).on('click', '.save_task_button', function () {
    const element = $(this).closest('.container_with_task_tracked_time').find('#employee_activity_period_duration');
    const value = element.val();
    const notificationSelector = '#new_task_popup #errors';
    if (!validStringForTime(value)) {
      showFlashMessage('Invalid time', 'danger', notificationSelector);
      const untrackedTimeIcon = $(element).next();
      $(element).remove();
      if (taskTrackedTimeSpan.html() === '') {
        untrackedTimeIcon.show();
      } else {
        taskTrackedTimeSpan.show();
      }
      return;
    }
    const duration = timeToFloat(value);
    const taskId = $('#new_task_popup').data('taskId');
    const projectId = $('#new_task_popup').data('projectId');
    const supervisorId = $('#tasks_popup').data('supervisorId');
    const employeeId = $('#new_task_popup').data('employeeId');
    const date = $('#new_task_popup').data('date');
    const selectorForAssignedEmployee = `.employee_mobile[data-employee-id="${employeeId}"][data-date="${date}"]`;
    const employeeDetails = $(selectorForAssignedEmployee).find('.employee_details');
    const activityPeriodParams = { activity_type: 'working_time', duration };

    $.ajax({
      url: '/employee_activity_periods',
      type: 'PUT',
      data: {
        date,
        project_id: projectId,
        supervisor_id: supervisorId,
        task_id: taskId,
        employee_activity_period: activityPeriodParams,
      },
      success(data) {
        if (data.status === 'ok') {
          $('#new_task_popup').dialog('destroy');
          const summaryStepData = $('#end-of-day-wizard #summary-step-data');
          const context = summaryStepData.length ? summaryStepData : $('#tasks_popup');
          showEmployeeDayTasks(date, context, true);
          showFlashMessage('Updated', 'success', notificationSelector);
        } else {
          showFlashMessage(data.status, 'success', notificationSelector);
        }
      },
    });
  });

  $(document).on('click', '.colored_employee_task_mobile', function () {
    const task = $(this);
    const taskId = task.data('id');
    const taskClass = task.data('taskClass');
    const taskDescription = task.data('taskDescription');
    const contextWithData = contextWithDataForNewTaskPopup($(this));
    const employeeId = contextWithData.data('employeeId');
    const date = contextWithData.data('date');
    const supervisorId = contextWithData.data('supervisorId');
    const projectId = contextWithData.data('projectId');
    const context = this;
    const selector = '#new_task_popup';
    const openCallback = function () {
      $.ajax({
        url: '/planned_employee_days/show_task_mobile',
        type: 'GET',
        data: { task_id: taskId, task_class: taskClass },
        success(data) {
          $(selector).html(data);
          $(selector).data('employeeId', employeeId);
          $(selector).data('taskId', taskId);
          $(selector).data('date', date);
          $(selector).data('supervisorId', supervisorId);
          $(selector).data('projectId', projectId);
          const commentInputBox = $(selector).find('#comment_input_box');
          const uploaderElem = commentInputBox.siblings('.photoupload_comment');
          uploaderElem.show();
          initializeUpload(commentInputBox, context);
          showUploadedPhotos();
        },
      });
      stylePopup(selector);
      $(selector).dialog('option', 'width', setMobilePopupWidth());
    };
    const closeCallback = function () {
      $(selector).dialog('destroy');
      showEmployeeDayTasks(date, contextWithData, true);
    };
    openPopup(selector, '', openCallback, closeCallback);
    return false;
  });

  $(document).on('click', '.employees_for_day_mobile.actual_status, .employees_for_day_mobile.future_status', function () {
    const date = $(this).closest('.employee_mobile').data('date');
    showEmployeeDayTasks(date, $(this).parents('.employee_mobile'), false);
  });

  function initializeUpload(input, context) {
    let parentElem = {};
    let taskId = '';
    if ($(context).parents('.employee_day_task').length) {
      parentElem = input.parents('.employee_day_task');
      taskId = parentElem.data('id');
    } else {
      parentElem = input.parents('.assigned_to_task_employee');
      taskId = parentElem.data('taskId');
    }

    if ($(document).find('#planner-mobile').length) {
      var mobileCounter = true;
      parentElem = input.parents('.container_with_task_tracked_time');
      taskId = parentElem.data('taskId');
    }
    parentElem.find('.photoupload_comment #fileupload').fileupload({
      dataType: 'html',
      replaceFileInput: false,
      fileInput: $('input:file'),
      add(e, data) {
        const taskClass = parentElem.data('taskClass');
        data.context = set_button_for_upload().addClass('nav-button')
          .appendTo(parentElem)
          .click(function () {
            data.url = `/planned_employee_days/leave_task_comment?task_id=${taskId}&task_class=${taskClass}`;
            data.context = $('#submit_button').text('Uploading...').replaceAll($(this));
            data.submit();
          });
      },
      done(e, data) {
        parentElem.find('.task_comments').html(data.result);
        taskCount = input.siblings('.task_comments').find('.panel').size();
        if (mobileCounter) {
          $(context).find('.comments_count').html(taskCount);
        } else {
          parentElem.find('.comments_count').html(taskCount);
        }
        showUploadedPhotos();
        input.val('');
        input.attr('placeholder', '');
        reset_inputs(data);
      },
      fail(e, data) {
        flash_upload_error('Something went wrong. Try again later.');
        reset_inputs(data);
      },
    }).on('fileuploadsubmit', (e, data) => {
      const input = $('#comment_input_box');
      data.formData = { message: input.val() };

      return validate_photo(data);
    });
  }

  $(document).on('click', '.employee_day_task .fa-comment', function () {
    const task = $(this).closest('.employee_day_task');
    const taskId = task.data('id');
    toggleCommentsSection(task, taskId, this);
  });

  $(document).on('click', '.assigned_to_task_employee .fa-comment', function () {
    const employee = $(this).closest('.assigned_to_task_employee');
    const taskId = employee.data('taskId');
    toggleCommentsSection(employee, taskId, this);
  });

  function toggleCommentsSection(parentElement, taskId, commentIcon) {
    const taskComments = parentElement.find('.task_comments');
    const taskClass = parentElement.data('taskClass');
    const data = { task_id: taskId, task_class: taskClass };
    const commentInputBox = parentElement.find('#comment_input_box');
    showComments(taskComments, commentInputBox, data, commentIcon);
  }

  function showComments(taskComments, commentInputBox, data, context) {
    const uploaderElem = commentInputBox.siblings('.photoupload_comment');
    if (taskComments.is(':visible')) {
      taskComments.hide();
      commentInputBox.hide();
      uploaderElem.hide();
    } else {
      $.ajax({
        url: '/planned_employee_days/task_comments',
        type: 'GET',
        data,
        success(data) {
          taskComments.html(data);
          commentInputBox.show();
          uploaderElem.show();
          taskComments.show();
          initializeUpload(commentInputBox, context);
          showUploadedPhotos();
        },
      });
    }
  }

  $(document).on('click', '.employee_day_task .delete_task', function () {
    const task = $(this).closest('.employee_day_task');
    const id = task.data('id');
    const taskClass = task.data('taskClass');
    $.ajax({
      url: '/planned_employee_days/destroy_task',
      type: 'DELETE',
      data: { task_id: id, task_class: taskClass },
      success(data) {
        if (data.status === 'ok') {
          task.remove();
          drawPlanner(false);
        } else {
          showFlashMessage(data.status, 'danger', '#tasks_popup');
        }
      },
    });
  });

  $(document).on('click', '#planned_task_final_step_popup #save_planned_task', () => {
    createPlannedTask();
  });

  function createPlannedTask() {
    const requestParams = getDataForSavingPlannedTask();
    $.ajax({
      url: 'planned_employee_days/create_planned_task',
      type: 'POST',
      data: requestParams,
      success(data) {
        if (data.status === 'ok') {
          $('#planned_task_final_step_popup').dialog('destroy');
          $('body').css({ overflow: 'inherit' });
          drawPlanner(false);
          getConfirmationAboutAddingEmployees(requestParams.task, data.task_ids);
        } else {
          showFlashMessage(data.status, 'danger', '#planned_task_final_step_popup #errors');
        }
      },
    });
  }

  function getDataForSavingPlannedTask() {
    const plannedFrom = $('#planned_task_final_step_popup #planned_from').val();
    const plannedTo = $('#planned_task_final_step_popup #planned_to').val();
    const requiredLabour = $('#planned_task_final_step_popup #required_labour').val();
    const supervisorId = $('#new_task_popup').data('supervisorId');
    const projectId = $('#new_task_popup').data('projectId');
    const data = {
      task: {
        planned_from: plannedFrom,
        planned_to: plannedTo,
        supervisor_id: supervisorId,
        required_labour: requiredLabour,
        project_id: projectId,
      },
    };
    if ($('#planned_task_final_step_popup #competency_id').length) {
      const competencyId = $('#planned_task_final_step_popup #competency_id').val();
      data.task.competency_id = parseInt(competencyId, 10);
    }
    if ($('#planned_task_final_step_popup #description').length) {
      data.task.description = $('#planned_task_final_step_popup #description').val();
    }
    return data;
  }

  $(document).on('keypress', '.employee_day_task #comment_input_box, .assigned_to_task_employee #comment_input_box, .task_comments_mobile #comment_input_box', function (e) {
    if (e.which === 13) {
      const commentInputBox = $(this);
      const container = $(this).closest('.container_with_task_tracked_time');
      const keyForTaskId = container.hasClass('employee_day_task') ? 'id' : 'taskId';
      const taskId = container.data(keyForTaskId);
      const taskClass = container.data('taskClass');
      const url = '/planned_employee_days/leave_task_comment';
      const message = $(this).val();
      $.ajax({
        url,
        type: 'POST',
        data: { message, task_id: taskId, task_class: taskClass },
        success(data) {
          commentInputBox.val('');
          const taskComments = container.find('.task_comments');
          taskComments.html(data);
          const commentsCount = taskComments.find('div.panel').length;
          container.find('.comments_count').text(commentsCount);
        },
      });
    }
  });

  $(document).on('click', '.delete_task_mobile', function () {
    const task = $(this).closest('.delete_task_mobile');
    const id = task.data('taskId');
    const taskClass = task.data('taskClass');
    $.ajax({
      url: '/planned_employee_days/destroy_task',
      type: 'DELETE',
      data: { task_id: id, task_class: taskClass },
      success(data) {
        if (data.status === 'ok') {
          if ($('#end-of-day-wizard').length) {
            $('#new_task_popup').dialog('destroy');
            const date = $('#summary-step-data').data('date');
            showEmployeeDayTasks(date, $('#summary-step-data'), true);
          } else {
            const taskId = $('#new_task_popup').data('taskId');
            const employeeId = $('#new_task_popup').data('employeeId');
            $('#new_task_popup').dialog('destroy');
            $('body').css({ overflow: 'inherit' });
            $('#tasks_popup').parents(`#toggle_employee_details_${employeeId}`).find(`[data-id='${taskId}']`).remove();
            drawPlanner(false);
            showFlashMessage('Task deleted', 'success', '#new_task_popup');
          }
        } else {
          showFlashMessage(data.status, 'danger', '#new_task_popup');
        }
      },
    });
    return false;
  });

  $(document).on('click', '.convert_planned_to_actual', function (event) {
    event.stopPropagation();
    const plannedTaskId = $(this).closest('.colored_employee_task_mobile').data('id');
    const edAttr = $(this).closest('.employee_mobile');
    const date = edAttr.data('date');
    const employeeId = edAttr.data('employee-id');
    const projectId = edAttr.data('project-id');
    const supervisorId = edAttr.data('supervisor-id');
    const data = {
      date,
      employee_id: employeeId,
      project_id: projectId,
      supervisor_id: supervisorId,
      planned_task_id: plannedTaskId,
    };
    $.ajax({
      url: 'planned_employee_days/create_task',
      type: 'POST',
      data,
      success(data) {
        const mobileDetails = edAttr.find(`#toggle_employee_details_${employeeId}`);
        mobileDetails.find('.employee_tasks').html(data);
        updateCounter('employees', edAttr);
        updateClockIconColor(mobileDetails);
      },
    });
    return false;
  });

  function updateCounter(type, attr) {
    if (attr.length === 0) { return; }
    const date = attr.data('date');
    const employee_id = attr.data('employee-id');
    const project_id = attr.data('project-id');
    const supervisor_id = attr.data('supervisor-id');
    const dateObj = new Date(date.substring(6, 10), date.substring(3, 5) - 1, date.substring(0, 2));
    const today = new Date();
    const futureDate = (dateObj > today);
    const employeeSection = $(`[data-date='${date}'][data-supervisor-id='${supervisor_id}'][data-employee-id='${employee_id}'][data-project-id='${project_id}']`);
    const tasks = employeeSection.find('.employee_tasks').children();
    const display = 'block';
    let totalCount = 0;
    let readyCount = 0;
    tasks.each(function (i) {
      if ($(this).data('task-class') === 'Task') { readyCount++; }
      totalCount++;
    });
    let state = '';
    let blockText = '';
    if (futureDate) {
      blockText = totalCount;
      state = 'future';
    } else {
      blockText = `${readyCount}/${totalCount}`;
      const completed = readyCount === totalCount;
      state = completed ? 'completed' : 'incompleted';
    }
    const classes = `${state}_task ${type}_counter task_hover`;
    const counter = employeeSection.find('.employees_counter');
    counter.html(blockText);
    counter.removeClass().addClass(classes);
  }

  $(document).on(clickEventType, '#new_task_popup .nav_competency', function () {
    const date = $('#tasks_popup').data('date');
    const employeeId = $('#tasks_popup').data('employeeId');
    const competencyId = $(this).data('id');
    const data = {
      date,
      employee_id: employeeId,
      competency_id: competencyId,
      only_competencies_section: true,
    };
    showCompetencies(data);
  });
});
